module.exports = __webpack_public_path__ + "media/searing_essence.3018a6b5.webm";